const React = require('react');
const CaptionC = require('../../../dumb/Caption/C');


module.exports = () => {
  return (
    <div>
      <div className="layoutRow fhaB fvaC">
        <CaptionC>Refer and earn</CaptionC>
      </div>
      <div className="layoutRow fhaS fvaC">
        <div className="f12 fw4 lh17 w430 (m|mt23)>p">
          <p className="fw7">Referral code : Lunu20</p>
          <p>
            Refer an active merchant and earn a 20% discount on Lunu commissions for 3 months.
            The referred merchant also gets a 20% discount.
          </p>
          <p>
            *Discount terms apply only when a merchant is succesfully
            onboarded and Lunu Widget/Terminal/Invoice service is activated.
          </p>
        </div>
      </div>
    </div>
  );
};
